import { useTranslation } from "react-i18next";
import "../cs.scss";
import "./csDocument.scss";
import MainLayout, { useLayout } from "../../../layouts/layout";
import { Breadcrumb, Button, Col, Form, Image, Row, Steps, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { _adr } from "../../../../address";
import { Content } from "antd/es/layout/layout";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import CSPrint from "../../updateDocument/cs-print";
import { useEffect, useRef, useState } from "react";
import { ExportDocument, base64ToFile, delay, exportNormalFile, fileToformData, urltoFile } from "../../../../tools/tools";
import Loading from "../../../auxiliary/loader/loading";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useDispatch, useSelector } from "react-redux";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import { Roles } from "../../../../tools/services";
import html2canvas from "html2canvas";
import ReactSignatureCanvas from "react-signature-canvas";

import { isMobile, isTablet } from "react-device-detect";

const CSDocument = () => {
  const [t] = useTranslation("global");
  const { setLayout } = useLayout();
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [frmDocument] = Form.useForm();
  const { addDocument } = useAPIPublic();
  const { simSwap, querySPPurchaseVProfileDealerById } = useDealer();
  const nav = useNavigate();
  const formData = useSelector((state) => state?.from?.swchange);
  const dispatch = useDispatch();
  const location = useLocation();

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const [signature, setSignature] = useState(false);
  // const signature = _currentUser?.roles?.includes(false);

  const [bgSingature, setBgSingature] = useState("");
  const [printData, setPrintData] = useState(false);
  const refBox = useRef("");

  const [hasErrorSign, setHasErrorSign] = useState(false);

  useEffect(() => {
    const callPurchase = async () => {
      if (location?.state?.spPurchaseId) {
        let response = await querySPPurchaseVProfileDealerById(location?.state?.spPurchaseId);
        if (response) {
          setSignature(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false);
          if (!(isMobile || isTablet ? _currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Get_Signature_FromCustomer) : false)) {
            setLayout(
              <CSPrint
                print={{
                  ...response,
                  kitno: formData?.kitno,
                  msisdn: formData?.msisdn,
                }}
                lang={formData?.certtype === 1 ? "en" : "fa"}
              />,
            );
          } else {
            setPrintData({
              ...response,
              kitno: formData?.kitno,
              msisdn: formData?.msisdn,
            });
          }
        }
      }
    };

    callPurchase();
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let valid = await frmDocument.validateFields();
      if (valid) {
        let resDoc = await addDocument(await fileToformData(valid.photo), "SWDocument");
        if (resDoc) {
          let payload = {
            // token: formData?.token,
            msisdn: formData?.msisdn,
            swapnationalid: formData?.documentid,
            swapdocumentid: resDoc?.Result,
            newiccid: formData?.kitno,
            simswapreason: formData?.reason,
            planid:process.env.REACT_APP_PLANID_CHANGE_SIMCARD
          };
          let response = await simSwap(payload);
          if (response) {
            nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.Final, {
              state: {
                swChange: {
                  Date: response?.dteDateTime,
                  ServiceType: response?.serviceType,
                  MSISDN: response?.msisdn,
                  NEWICCID: response?.iccIdNew,
                  StrFollwUpCode: response?.strFollwUpCode,
                },
              },
            });
          }
        }
      }
    } catch (error) {
      setHasErrorSign(true);
    }
    setIsLoading(false);
  };
  const handleGetImage = async (value) => {
    frmDocument.setFieldValue("photo", value);
  };

  const handleGetCanvas = (img) => {
    setBgSingature(img);
  };

  useEffect(() => {
    const setChangeCanvas = () => {
      if (bgSingature) {
        let canvas = document.getElementById("canvasDoc");
        let parentElement = canvas.parentElement;
        canvas.width = parentElement.clientWidth;
        canvas.height = parentElement.clientHeight;
      }
    };
    setChangeCanvas();
    window.addEventListener("orientationchange", setChangeCanvas);

    return () => {
      window.removeEventListener("orientationchange", setChangeCanvas);
    };
  }, [bgSingature]);

  const clearHandler = () => {
    let canvas = document.getElementById("canvasDoc");
    let context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    frmDocument.setFieldValue("photo", null);
  };
  const writeSignatureHandler = async () => {
    html2canvas(refBox.current).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/png");
      frmDocument.setFieldValue("photo", await base64ToFile(imgData));
    });
  };
  return (
    <>
      <div className="container-main container-cs">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.validPage.title") }]}
          />
          <div className="title-page">
            <h3>{t("simcardreplacement.validPage.title")}</h3>
            <p></p>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main cs-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="g-format-steps">
                  <div className="holder-step">
                    <Steps
                      size="small"
                      className="step-wizard"
                      current={3}
                      items={[
                        {
                          title: "احراز هویت",
                        },
                        {
                          title: "مشخصات سیم‌کارت",
                        },
                        {
                          title: "پیش فاکتور",
                        },
                        {
                          title: "فرم تعویض سیم‌کارت",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="holder-document-page">
                  <div className="holder-document">
                    {signature ? (
                      <Row>
                        <Col xl={10} lg={24} style={{ margin: "auto" }}>
                          <div className="holder-signature-on-document">
                            <div ref={refBox} className="box-signature">
                              {bgSingature?.length === 0 && <>{printData && <CSPrint print={printData} value={handleGetCanvas} canvas={true} />}</>}
                              <ReactSignatureCanvas
                                penColor="blue"
                                canvasProps={{
                                  id: "canvasDoc",
                                  width: "100%",
                                  height: "100%",
                                  className: "sigCanvas",
                                }}
                                clearOnResize={false}
                                backgroundColor="transparent"
                                onEnd={writeSignatureHandler}
                              />
                              <img src={bgSingature} alt="" width={"100%"} />
                            </div>
                            {hasErrorSign && <p style={{ color: "#ff4d4f" }}>لطفا فرم نمایش داده را امضا کنید</p>}
                            <div className="holder-button">
                              <Button onClick={clearHandler} className="btn-normal">
                                پاک کردن
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <div className="item-step">
                          <p>1- نسبت به چاپ سند اقدام فرمایید</p>
                          <Button
                            className="btn-normal btn-print"
                            type="default"
                            icon={<i className="icon-print"></i>}
                            onClick={() => {
                              window.print();
                              setIsDisabled(false);
                            }}
                          >
                            چاپ سند
                          </Button>
                        </div>
                      </>
                    )}
                    <div className="item-step" style={{ display: signature ? "none" : "block" }}>
                      <p>2- سند مهر و امضا شده را بارگذاری کنید.</p>
                      <Row gutter={20}>
                        <Col span={12} lg={15} md={20} sm={24} xs={24}>
                          <Form form={frmDocument} layout="vertical">
                            <Form.Item
                              name="photo"
                              rules={[
                                {
                                  required: true,
                                  message: t("validation.required"),
                                },
                              ]}
                              label="تصویر مدرک"
                            >
                              <ResizeImage disabled={isDisabled} exportImage={handleGetImage} />
                            </Form.Item>
                          </Form>
                        </Col>
                        {/* <Col span={12} style={{ margin: "auto" }}>
                          <div className="hold-text">
                            <ul>
                              <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                              <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                              <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                            </ul>
                          </div>
                        </Col> */}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button className="btn-normal btn-aptel" type="primary" onClick={handleSubmit} danger>
                    مرحله بعد
                  </Button>
                  <Button
                    className="btn-normal"
                    onClick={() =>
                      nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.PreFactor)
                    }
                    type="default"
                  >
                    بازگشت
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </div>

      <Loading isOpen={isLoading} />
    </>
  );
};

export default CSDocument;
